import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import icTank from 'assets/svg/ic_tank_V2.svg';
import icMarksman from 'assets/svg/ic_marksman_V2.svg';
import icAssassin from 'assets/svg/ic_assassin_V2.svg';
import { HeroClassName, NtfHeroClassType } from 'src/utils/types';
const iconMap = {
  [NtfHeroClassType.TANK]: icTank,
  [NtfHeroClassType.MARKSMAN]: icMarksman,
  [NtfHeroClassType.ASSASSIN]: icAssassin
};

const HeroClassIcon = ({
  value,
  small
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, small && styles.small)
  }, /*#__PURE__*/React.createElement("img", {
    src: iconMap[value]
  }), !small && /*#__PURE__*/React.createElement("p", {
    className: styles.heroClassName
  }, HeroClassName[value]));
};

export default HeroClassIcon;